import React, { useState, useEffect } from 'react';
import { db, storage } from '../../../firebase';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { registrarMarcaEnCatalogo } from '../../../services/marcasCatalogoService';

export default function CrearEmpresaPublica({ onClose, onSuccess, preselectedAgenteId }) {
  console.log('🚀 CrearEmpresaPublica - VERSIÓN MEJORADA se está cargando');
  const [formData, setFormData] = useState({
    nombre: '',
    direccion: '',
    telefono: '',
    email: '',
    sitio_web: '',
    horario_atencion: '',
    categorias: [],
    marcas: [],
    logo_url: '',
    descripcion: '',
    rubro: '',
    lat: '',
    lng: ''
  });
  
  // Estados para el campo rubro
  const [mostrarInputRubro, setMostrarInputRubro] = useState(false);
  
  // Rubros predefinidos
  const rubrosPredefinidos = [
    'Repuestos',
    'Servicios',
    'Talleres',
    'Lubricantes',
    'Vulcanización',
    'Neumáticos',
    'Motos',
    'Accesorios',
    'Ferretería',
    'Electricidad Automotriz',
    'Mecánica General',
    'Pintura y Carrocería',
    'Vidrios',
    'Audio y Alarmas',
    'Frenos',
    'Suspensión',
    'Transmisión',
    'Radiadores',
    'Baterías',
    'Grúas',
    'Lavado y Detailing',
    'Seguros',
    'Venta de Vehículos',
    'Otros'
  ];

  // Estado para horarios estructurados
  const [horarios, setHorarios] = useState({
    lunes: { activo: true, inicio: '09:00', fin: '18:00' },
    martes: { activo: true, inicio: '09:00', fin: '18:00' },
    miercoles: { activo: true, inicio: '09:00', fin: '18:00' },
    jueves: { activo: true, inicio: '09:00', fin: '18:00' },
    viernes: { activo: true, inicio: '09:00', fin: '18:00' },
    sabado: { activo: true, inicio: '09:00', fin: '14:00' },
    domingo: { activo: false, inicio: '10:00', fin: '14:00' }
  });

  const [categorias, setCategorias] = useState([]);
  const [marcasDisponibles, setMarcasDisponibles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState('');
  const [logoUploaded, setLogoUploaded] = useState(false);
  const [logoUploading, setLogoUploading] = useState(false);
  const [logoError, setLogoError] = useState('');
  
  // Servicios principales predefinidos (Recomendados)
  const [serviciosPredefinidos] = useState([
    { 
      id: 'repuestos', 
      nombre: 'Repuestos', 
      icono: '🔧', 
      color: 'blue',
      descripcion: 'Venta de repuestos y piezas automotrices',
      destacado: true
    },
    { 
      id: 'accesorios', 
      nombre: 'Accesorios', 
      icono: '✨', 
      color: 'green',
      descripcion: 'Accesorios y complementos para vehículos',
      destacado: true
    }
  ]);

  // Servicios adicionales (Otros Servicios)
  const [serviciosAdicionales] = useState([
    { id: 'revision_tecnica', nombre: 'Revisión Técnica', icono: '🔧', color: 'blue' },
    { id: 'mecanica_general', nombre: 'Mecánica General', icono: '⚙️', color: 'green' },
    { id: 'vulcanizacion', nombre: 'Vulcanización', icono: '🛞', color: 'purple' },
    { id: 'neumaticos', nombre: 'Neumáticos', icono: '🚗', color: 'red' },
    { id: 'frenos', nombre: 'Frenos', icono: '🛑', color: 'orange' },
    { id: 'suspension', nombre: 'Suspensión', icono: '🔩', color: 'indigo' },
    { id: 'motor', nombre: 'Motor', icono: '🔋', color: 'yellow' },
    { id: 'electricidad', nombre: 'Electricidad', icono: '⚡', color: 'pink' },
    { id: 'aire_acondicionado', nombre: 'Aire Acondicionado', icono: '❄️', color: 'cyan' },
    { id: 'baterias', nombre: 'Baterías', icono: '🔋', color: 'amber' },
    { id: 'lubricentro', nombre: 'Lubricentro', icono: '🛢️', color: 'slate' },
    { id: 'pintura', nombre: 'Pintura', icono: '🎨', color: 'rose' }
  ]);
  
  const [servicioPersonalizado, setServicioPersonalizado] = useState('');
  const [serviciosPersonalizados, setServiciosPersonalizados] = useState([]);
  
  // Estados para búsqueda y agregar marcas personalizadas
  const [busquedaMarca, setBusquedaMarca] = useState('');
  const [marcasPersonalizadas, setMarcasPersonalizadas] = useState([]);
  
  // Estados para asignar agente
  const [agentesDisponibles, setAgentesDisponibles] = useState([]);
  const [agenteSeleccionado, setAgenteSeleccionado] = useState('');
  const [loadingAgentes, setLoadingAgentes] = useState(false);

  useEffect(() => {
    cargarCategorias();
    cargarAgentes();
    cargarMarcas();
  }, []);

  // Función para generar texto de horarios para mostrar
  const generarTextoHorarios = () => {
    const diasActivos = Object.entries(horarios)
      .filter(([_, config]) => config.activo)
      .map(([dia, config]) => {
        const nombreDia = dia === 'lunes' ? 'Lun' : 
                          dia === 'martes' ? 'Mar' :
                          dia === 'miercoles' ? 'Mié' :
                          dia === 'jueves' ? 'Jue' :
                          dia === 'viernes' ? 'Vie' :
                          dia === 'sabado' ? 'Sáb' : 'Dom';
        return `${nombreDia} ${config.inicio}-${config.fin}`;
      });
    
    return diasActivos.join(', ');
  };

  // Actualizar texto de horarios cuando cambien los horarios estructurados
  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      horario_atencion: generarTextoHorarios()
    }));
  }, [horarios]);

  const cargarCategorias = async () => {
    try {
      const snapshot = await getDocs(collection(db, 'categorias'));
      const categoriasData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setCategorias(categoriasData);
    } catch (error) {
      console.error('Error cargando categorías:', error);
    }
  };

  const cargarAgentes = async () => {
    try {
      setLoadingAgentes(true);
      const snapshot = await getDocs(collection(db, 'agentes'));
      const agentesData = snapshot.docs
        .map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        .filter(agente => agente.activo !== false); // Solo agentes activos
      setAgentesDisponibles(agentesData);
      // Si hay agente preseleccionado (p. ej. cuando el agente crea la empresa), asignarlo
      if (preselectedAgenteId && agentesData.some(a => a.id === preselectedAgenteId)) {
        setAgenteSeleccionado(preselectedAgenteId);
      }
    } catch (error) {
      console.error('Error cargando agentes:', error);
    } finally {
      setLoadingAgentes(false);
    }
  };

  const cargarMarcas = async () => {
    try {
      const snapshot = await getDocs(collection(db, 'marcas'));
      const marcasData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setMarcasDisponibles(marcasData);
      
      // Pre-seleccionar "Multimarca" si existe
      const multimarca = marcasData.find(marca => 
        marca.nombre.toLowerCase().includes('multimarca') || 
        marca.nombre.toLowerCase().includes('multi-marca')
      );
      
      if (multimarca) {
        setFormData(prev => ({
          ...prev,
          marcas: [multimarca.nombre] // Guardar el nombre, no el ID
        }));
      }
    } catch (error) {
      console.error('Error cargando marcas:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'telefono') {
      const v = String(value).replace(/\D/g, '').slice(0, 9);
      setFormData(prev => ({ ...prev, [name]: v }));
      return;
    }
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleMarcaChange = (marcaNombre) => {
    setFormData(prev => ({
      ...prev,
      marcas: prev.marcas.includes(marcaNombre) 
        ? prev.marcas.filter(nombre => nombre !== marcaNombre)
        : [...prev.marcas, marcaNombre]
    }));
  };

  const handleCategoriaChange = (categoriaNombre) => {
    setFormData(prev => ({
      ...prev,
      categorias: prev.categorias.includes(categoriaNombre) 
        ? prev.categorias.filter(nombre => nombre !== categoriaNombre)
        : [...prev.categorias, categoriaNombre]
    }));
  };

  // Funciones para servicios personalizados
  const agregarServicioPersonalizado = () => {
    if (servicioPersonalizado.trim() && !serviciosPersonalizados.includes(servicioPersonalizado.trim())) {
      const nuevoServicio = servicioPersonalizado.trim();
      setServiciosPersonalizados(prev => [...prev, nuevoServicio]);
      setFormData(prev => ({
        ...prev,
        categorias: [...prev.categorias, nuevoServicio]
      }));
      setServicioPersonalizado('');
    }
  };

  const eliminarServicioPersonalizado = (servicio) => {
    setServiciosPersonalizados(prev => prev.filter(s => s !== servicio));
    setFormData(prev => ({
      ...prev,
      categorias: prev.categorias.filter(cat => cat !== servicio)
    }));
  };

  const handleServicioPredefinidoChange = (servicio) => {
    setFormData(prev => ({
      ...prev,
      categorias: prev.categorias.includes(servicio) 
        ? prev.categorias.filter(s => s !== servicio)
        : [...prev.categorias, servicio]
    }));
  };

  const handleServicioAdicionalChange = (servicio) => {
    setFormData(prev => ({
      ...prev,
      categorias: prev.categorias.includes(servicio) 
        ? prev.categorias.filter(s => s !== servicio)
        : [...prev.categorias, servicio]
    }));
  };

  // Función para manejar cambios en horarios
  const handleHorarioChange = (dia, campo, valor) => {
    setHorarios(prev => ({
      ...prev,
      [dia]: {
        ...prev[dia],
        [campo]: campo === 'activo' ? valor : valor
      }
    }));
  };

  const handleLogoChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      setLogoUploaded(false);
      setLogoError('');
      
      // Crear preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setLogoPreview(e.target.result);
      };
      reader.readAsDataURL(file);
      
      // Subir logo automáticamente
      try {
        await uploadLogoToStorage(file);
      } catch (error) {
        console.error('Error en subida automática:', error);
      }
    }
  };

  const uploadLogoToStorage = async (file) => {
    if (!file) return null;
    
    setLogoUploading(true);
    setLogoError('');
    
    try {
      // Crear nombre único para el archivo
      const timestamp = Date.now();
      const fileName = `auto-${Math.random().toString(36).substr(2, 9)}-${timestamp}`;
      const fileExtension = file.name.split('.').pop();
      const fullFileName = `${fileName}.${fileExtension}`;
      
      // Referencia en Firebase Storage
      const storageRef = ref(storage, `logos/empresas/${fullFileName}`);
      
      console.log('📁 Subiendo logo:', file.name);
      console.log('📍 Ruta en Storage:', storageRef.fullPath);
      
      // Metadata explícita para evitar error 412 (Precondition Failed) en algunos buckets
      const metadata = {
        contentType: file.type || 'image/png',
        cacheControl: 'public, max-age=31536000'
      };
      
      // Subir archivo
      const snapshot = await uploadBytes(storageRef, file, metadata);
      console.log('✅ Logo subido exitosamente:', snapshot.metadata.fullPath);
      
      // Obtener URL de descarga
      const downloadURL = await getDownloadURL(snapshot.ref);
      console.log('🔗 URL de descarga obtenida:', downloadURL);
      
      setLogoUploaded(true);
      setLogoUploading(false);
      
      return {
        gsUrl: `gs://${storageRef.bucket}/${storageRef.fullPath}`,
        downloadURL: downloadURL
      };
    } catch (error) {
      console.error('❌ Error subiendo logo:', error);
      const msg = error?.message || '';
      const is412 = error?.code === 'storage/unknown' || msg.includes('412') || (error?.serverResponse && String(error.serverResponse).includes('412'));
      const mensaje = is412
        ? 'Error al subir (412). Revisa en Firebase Console: cuenta de facturación activa y Storage vinculado al proyecto.'
        : `Error al subir logo: ${msg}`;
      setLogoError(mensaje);
      setLogoUploading(false);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validaciones básicas (sitio web no es obligatorio)
      if (!formData.nombre || !formData.direccion || formData.categorias.length === 0) {
        alert('Por favor complete todos los campos obligatorios (nombre, dirección y al menos un servicio)');
        setLoading(false);
        return;
      }

      // Validar que el logo esté subido si se seleccionó un archivo
      if (logoFile && !logoUploaded) {
        alert('Por favor espera a que el logo se suba completamente antes de guardar la empresa');
        setLoading(false);
        return;
      }

      let logoData = null;
      
      // Si hay un archivo de logo, subirlo a Storage
      if (logoFile) {
        logoData = await uploadLogoToStorage(logoFile);
      } else if (formData.logo_url) {
        // Si solo hay URL, usar esa
        logoData = {
          gsUrl: formData.logo_url,
          downloadURL: formData.logo_url
        };
      }

      // Las categorías y marcas ya están como nombres, no como IDs
      const categoriasSeleccionadas = formData.categorias; // Ya son nombres
      const marcasSeleccionadas = formData.marcas; // Ya son nombres
      
      console.log('🏷️ Categorías seleccionadas:', formData.categorias);
      console.log('🚗 Marcas seleccionadas:', formData.marcas);

      // Determinar si es empresa de Revisión Técnica
      const esRevisionTecnica = categoriasSeleccionadas.includes('Revisión Técnica');
      
      // Obtener datos del agente si se seleccionó uno
      let agenteData = null;
      if (agenteSeleccionado) {
        agenteData = agentesDisponibles.find(a => a.id === agenteSeleccionado);
      }

      const empresaData = {
        ...formData,
        telefono: formData.telefono.length === 9 ? '+56' + formData.telefono : (formData.telefono || ''),
        estado: agenteSeleccionado ? 'pendiente_validacion' : 'ingresada', // Si tiene agente, pasa a pendiente_validacion
        tipoEmpresa: 'proveedor', // Siempre proveedor en MVP
        tipo_empresa: 'publica', // Mantener para compatibilidad (empresa pública visible para todos)
        es_comunidad: false, // No es parte de la comunidad aún
        fecha_creacion: new Date(),
        fecha_actualizacion: new Date(),
        creado_por: 'admin',
        // Campo especial para identificar empresas de revisión técnica
        tipoServicio: esRevisionTecnica ? 'revision_tecnica' : 'general',
        // Mapear campos correctamente
        web: formData.sitio_web,
        categoria: categoriasSeleccionadas.join(', '), // Categoría como string para compatibilidad
        categorias: categoriasSeleccionadas, // Nombres de categorías
        servicios: categoriasSeleccionadas, // Servicios (igual a categorías)
        logo: logoData ? logoData.gsUrl : '', // Guardar la URL gs:// para referencia
        logo_url: logoData ? logoData.downloadURL : formData.logo_url, // URL de descarga para visualización
        horario_atencion: generarTextoHorarios(), // Texto legible para compatibilidad
        horarios: horarios, // Estructura completa de horarios
        marcas: marcasSeleccionadas, // Nombres de marcas
        // Datos del agente asignado (si aplica)
        ...(agenteSeleccionado && {
          agenteAsignado: agenteSeleccionado,
          agente_nombre: agenteData?.nombre || agenteData?.email || '',
          agente_email: agenteData?.email || '',
          fecha_asignacion_agente: new Date(),
          etapa_proceso: 'visita_campo'
        })
      };

      console.log('📝 Datos de empresa a guardar:', empresaData);
      console.log('🕐 Horarios estructurados:', horarios);
      console.log('📝 Texto de horarios:', generarTextoHorarios());
      console.log('🕐 Horario de atención guardado:', empresaData.horario_atencion);

      // Guardar en Firestore
      const docRef = await addDoc(collection(db, 'empresas'), empresaData);
      console.log('✅ Empresa creada exitosamente con ID:', docRef.id);
      
      alert('¡Empresa pública creada exitosamente!');
      onSuccess?.();
      onClose?.();
    } catch (error) {
      console.error('❌ Error creando empresa:', error);
      alert(`Error creando empresa: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-6xl w-full max-h-[95vh] overflow-hidden">
        {/* Header mejorado */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-6">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
                <span className="text-2xl">🏢</span>
              </div>
              <div>
                <h2 className="text-2xl font-bold">Crear Empresa Pública</h2>
                <p className="text-blue-100 text-sm">Registra una nueva empresa en el directorio</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="w-10 h-10 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-lg flex items-center justify-center transition-all duration-200"
            >
              <span className="text-xl font-bold">×</span>
            </button>
          </div>
        </div>

        {/* Contenido con scroll */}
        <div className="overflow-y-auto max-h-[calc(95vh-120px)]">
          <div className="p-6">
            {/* Banner de verificación temporal */}
            <div className="bg-gradient-to-r from-green-500 to-blue-500 text-white p-4 rounded-xl mb-6 text-center">
              <h3 className="text-lg font-bold">✅ VERSIÓN MEJORADA CARGADA</h3>
              <p className="text-sm">Diseño renovado con servicios destacados</p>
            </div>

        <form onSubmit={handleSubmit} className="space-y-8">
          {/* Información Básica */}
          <div className="bg-gray-50 rounded-xl p-6">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                <span className="text-blue-600 text-lg">ℹ️</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Información Básica</h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              
              <div className="space-y-2">
                <label className="block text-sm font-semibold text-gray-700">
                  Nombre de la Empresa *
                </label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  className="w-full p-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white"
                  placeholder="Ej: Taller Automotriz San Miguel"
                  required
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-semibold text-gray-700">
                  Dirección *
                </label>
                <input
                  type="text"
                  name="direccion"
                  value={formData.direccion}
                  onChange={handleChange}
                  className="w-full p-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white"
                  placeholder="Calle, número, comuna, región"
                  required
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-semibold text-gray-700">
                  Teléfono
                </label>
                <div className="flex border-2 border-gray-200 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500 bg-white">
                  <span className="flex items-center px-4 bg-gray-100 text-gray-600 font-medium border-r border-gray-200">+56</span>
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={9}
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    className="flex-1 p-4 border-0 focus:ring-0 min-w-0"
                    placeholder="912345678"
                  />
                </div>
                <p className="text-xs text-gray-500">Ingresa los 9 dígitos del celular de la empresa (ej: 912345678)</p>
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-semibold text-gray-700">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white"
                  placeholder="contacto@empresa.com"
                />
              </div>
              
              {/* Campo Rubro */}
              <div className="space-y-2">
                <label className="block text-sm font-semibold text-gray-700">
                  Rubro
                </label>
                {!mostrarInputRubro ? (
                  <select
                    name="rubro"
                    value={formData.rubro}
                    onChange={(e) => {
                      if (e.target.value === '__otro__') {
                        setMostrarInputRubro(true);
                        setFormData(prev => ({ ...prev, rubro: '' }));
                      } else {
                        handleChange(e);
                      }
                    }}
                    className="w-full p-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white"
                  >
                    <option value="">Seleccionar rubro</option>
                    {rubrosPredefinidos.map(rubro => (
                      <option key={rubro} value={rubro}>{rubro}</option>
                    ))}
                    <option value="__otro__">➕ Ingresar otro rubro...</option>
                  </select>
                ) : (
                  <div className="flex gap-2">
                    <input
                      type="text"
                      name="rubro"
                      value={formData.rubro}
                      onChange={handleChange}
                      placeholder="Ingrese el rubro de la empresa..."
                      className="flex-1 p-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        setMostrarInputRubro(false);
                        if (!formData.rubro) {
                          setFormData(prev => ({ ...prev, rubro: '' }));
                        }
                      }}
                      className="px-4 py-2 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 text-sm font-medium"
                      title="Volver a seleccionar del listado"
                    >
                      📋 Lista
                    </button>
                  </div>
                )}
                <p className="text-xs text-gray-500">
                  {mostrarInputRubro 
                    ? 'Ingrese el rubro manualmente o haga clic en "📋 Lista" para seleccionar del listado'
                    : 'Seleccione un rubro o elija "Ingresar otro rubro..." para escribir uno personalizado'}
                </p>
              </div>
            </div>

          </div>

          {/* Información de Negocio */}
          <div className="bg-gray-50 rounded-xl p-6">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
                <span className="text-green-600 text-lg">🌐</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Información de Negocio</h3>
            </div>
            
            <div className="space-y-6">
              
              <div className="space-y-2">
                <label className="block text-sm font-semibold text-gray-700">
                  Sitio Web (opcional)
                </label>
                <input
                  type="url"
                  name="sitio_web"
                  value={formData.sitio_web}
                  onChange={handleChange}
                  placeholder="https://www.empresa.com"
                  className="w-full p-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white"
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-semibold text-gray-700">
                  Descripción de la Empresa
                </label>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleChange}
                  rows="4"
                  className="w-full p-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white resize-none"
                  placeholder="Describe los servicios que ofrece tu empresa, años de experiencia, especialidades, etc..."
                />
              </div>

              <div className="space-y-3">
                <label className="block text-sm font-semibold text-gray-700">
                  Logo de la Empresa
                </label>
                
                {/* Input para archivo mejorado */}
                <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-blue-400 transition-colors">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleLogoChange}
                    className="hidden"
                    id="logo-upload"
                  />
                  <label htmlFor="logo-upload" className="cursor-pointer">
                    <div className="text-gray-400 mb-2">
                      <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <p className="text-sm text-gray-600 font-medium">Haz clic para subir logo</p>
                    <p className="text-xs text-gray-500 mt-1">JPG, PNG, GIF • Máximo 5MB</p>
                  </label>
                </div>

                {/* Preview del logo mejorado */}
                {logoPreview && (
                  <div className="bg-white border-2 border-gray-200 rounded-xl p-4">
                    <div className="flex items-center gap-4">
                      <div className="relative">
                        <img 
                          src={logoPreview} 
                          alt="Preview del logo" 
                          className="h-24 w-24 object-contain border border-gray-200 rounded-lg"
                        />
                        {logoUploading && (
                          <div className="absolute inset-0 bg-white bg-opacity-75 rounded-lg flex items-center justify-center">
                            <div className="w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                          </div>
                        )}
                      </div>
                      
                      {/* Estado del logo */}
                      <div className="flex-1">
                        <h4 className="text-sm font-semibold text-gray-800 mb-2">Vista previa del logo</h4>
                        
                        {logoUploading && (
                          <div className="flex items-center gap-2 text-blue-600">
                            <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                            <span className="text-sm font-medium">Subiendo logo...</span>
                          </div>
                        )}
                        
                        {logoUploaded && (
                          <div className="flex items-center gap-2 text-green-600">
                            <span className="text-lg">✅</span>
                            <span className="text-sm font-medium">Logo subido exitosamente</span>
                          </div>
                        )}
                        
                        {logoError && (
                          <div className="flex items-center gap-2 text-red-600">
                            <span className="text-lg">❌</span>
                            <span className="text-sm font-medium">{logoError}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Input para URL (opcional si no hay archivo) */}
                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-600 mb-1">
                    O URL del Logo (opcional)
                  </label>
                  <input
                    type="url"
                    name="logo_url"
                    value={formData.logo_url}
                    onChange={handleChange}
                    placeholder="https://ejemplo.com/logo.png"
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    Si no subes un archivo, puedes proporcionar una URL
                  </p>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Horarios de Atención *
                </label>
                <div className="space-y-3 p-4 border border-gray-200 rounded-lg bg-gray-50">
                  {Object.entries(horarios).map(([dia, config]) => (
                    <div key={dia} className="flex items-center space-x-3">
                      <label className="flex items-center space-x-2 min-w-[80px]">
                        <input
                          type="checkbox"
                          checked={config.activo}
                          onChange={(e) => handleHorarioChange(dia, 'activo', e.target.checked)}
                          className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        />
                        <span className="text-sm font-medium capitalize">
                          {dia === 'lunes' ? 'Lunes' : 
                           dia === 'martes' ? 'Martes' :
                           dia === 'miercoles' ? 'Miércoles' :
                           dia === 'jueves' ? 'Jueves' :
                           dia === 'viernes' ? 'Viernes' :
                           dia === 'sabado' ? 'Sábado' : 'Domingo'}
                        </span>
                      </label>
                      
                      {config.activo && (
                        <>
                          <input
                            type="time"
                            value={config.inicio}
                            onChange={(e) => handleHorarioChange(dia, 'inicio', e.target.value)}
                            className="border border-gray-300 rounded px-2 py-1 text-sm"
                          />
                          <span className="text-gray-500">a</span>
                          <input
                            type="time"
                            value={config.fin}
                            onChange={(e) => handleHorarioChange(dia, 'fin', e.target.value)}
                            className="border border-gray-300 rounded px-2 py-1 text-sm"
                          />
                        </>
                      )}
                      
                      {!config.activo && (
                        <span className="text-gray-400 text-sm">Cerrado</span>
                      )}
                    </div>
                  ))}
                  
                  {/* Resumen de horarios */}
                  <div className="mt-3 pt-3 border-t border-gray-200">
                    <div className="flex justify-between items-center">
                      <p className="text-sm text-gray-600">
                        <strong>Resumen:</strong> {generarTextoHorarios()}
                      </p>
                      <button
                        type="button"
                        onClick={() => setHorarios({
                          lunes: { activo: true, inicio: '09:00', fin: '18:00' },
                          martes: { activo: true, inicio: '09:00', fin: '18:00' },
                          miercoles: { activo: true, inicio: '09:00', fin: '18:00' },
                          jueves: { activo: true, inicio: '09:00', fin: '18:00' },
                          viernes: { activo: true, inicio: '09:00', fin: '18:00' },
                          sabado: { activo: true, inicio: '09:00', fin: '14:00' },
                          domingo: { activo: false, inicio: '10:00', fin: '14:00' }
                        })}
                        className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded hover:bg-blue-200 transition-colors"
                      >
                        🔄 Restaurar por defecto
                      </button>
                    </div>
                  </div>
                </div>
              </div>

          {/* Servicios */}
          <div className="bg-gray-50 rounded-xl p-6">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
                <span className="text-purple-600 text-lg">⚙️</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Servicios que Ofrece *</h3>
            </div>
                
                {/* Servicios Principales - Destacados */}
                <div className="mb-8">
                  <div className="flex items-center mb-4">
                    <h4 className="text-lg font-semibold text-gray-700">Servicios Principales</h4>
                    <span className="ml-2 bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">Recomendados</span>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {serviciosPredefinidos.map(servicio => (
                      <label 
                        key={servicio.id} 
                        className={`group relative flex flex-col items-center p-6 rounded-xl border-2 cursor-pointer transition-all duration-300 hover:shadow-lg hover:scale-105 ${
                          formData.categorias.includes(servicio.nombre)
                            ? `border-${servicio.color}-500 bg-${servicio.color}-50 shadow-md`
                            : 'border-gray-200 bg-white hover:border-gray-300'
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={formData.categorias.includes(servicio.nombre)}
                          onChange={() => handleServicioPredefinidoChange(servicio.nombre)}
                          className="sr-only"
                        />
                        <div className="text-4xl mb-3">{servicio.icono}</div>
                        <h5 className="text-lg font-semibold text-gray-800 mb-2 text-center">
                          {servicio.nombre}
                        </h5>
                        <p className="text-sm text-gray-600 text-center leading-relaxed">
                          {servicio.descripcion}
                        </p>
                        {formData.categorias.includes(servicio.nombre) && (
                          <div className="absolute top-2 right-2">
                            <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                              <span className="text-white text-sm">✓</span>
                            </div>
                          </div>
                        )}
                      </label>
                    ))}
                  </div>
                </div>

                {/* Servicios Adicionales */}
                <div className="mb-8">
                  <h4 className="text-lg font-semibold text-gray-700 mb-4">Otros Servicios</h4>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
                    {serviciosAdicionales.map(servicio => (
                      <label 
                        key={servicio.id} 
                        className={`flex flex-col items-center p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 hover:shadow-md ${
                          formData.categorias.includes(servicio.nombre)
                            ? `border-${servicio.color}-500 bg-${servicio.color}-50`
                            : 'border-gray-200 bg-white hover:border-gray-300'
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={formData.categorias.includes(servicio.nombre)}
                          onChange={() => handleServicioAdicionalChange(servicio.nombre)}
                          className="sr-only"
                        />
                        <div className="text-2xl mb-2">{servicio.icono}</div>
                        <span className="text-sm font-medium text-gray-700 text-center">
                          {servicio.nombre}
                        </span>
                        {formData.categorias.includes(servicio.nombre) && (
                          <div className="mt-2">
                            <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center">
                              <span className="text-white text-xs">✓</span>
                            </div>
                          </div>
                        )}
                      </label>
                    ))}
                  </div>
                </div>

                {/* Servicios Personalizados */}
                <div className="mb-6">
                  <h4 className="text-lg font-semibold text-gray-700 mb-4">Agregar Servicio Personalizado</h4>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <div className="flex space-x-3">
                      <input
                        type="text"
                        value={servicioPersonalizado}
                        onChange={(e) => setServicioPersonalizado(e.target.value)}
                        placeholder="Ej: Alineación y balanceo, Reparación de aire acondicionado..."
                        className="flex-1 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onKeyPress={(e) => e.key === 'Enter' && agregarServicioPersonalizado()}
                      />
                      <button
                        type="button"
                        onClick={agregarServicioPersonalizado}
                        disabled={!servicioPersonalizado.trim()}
                        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors font-medium"
                      >
                        Agregar
                      </button>
                    </div>
                    
                    {/* Lista de servicios personalizados */}
                    {serviciosPersonalizados.length > 0 && (
                      <div className="mt-4">
                        <p className="text-sm text-gray-600 mb-3">Servicios personalizados agregados:</p>
                        <div className="flex flex-wrap gap-2">
                          {serviciosPersonalizados.map(servicio => (
                            <span 
                              key={servicio} 
                              className="bg-purple-100 text-purple-800 px-4 py-2 rounded-full text-sm flex items-center space-x-2 font-medium"
                            >
                              <span>{servicio}</span>
                              <button
                                type="button"
                                onClick={() => eliminarServicioPersonalizado(servicio)}
                                className="text-purple-600 hover:text-purple-800 ml-1 font-bold"
                              >
                                ×
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Validación y resumen */}
                {formData.categorias.length === 0 && (
                  <div className="bg-red-50 border-l-4 border-red-400 rounded-lg p-4">
                    <div className="flex items-center">
                      <div className="text-red-400 mr-3">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <p className="text-sm text-red-700 font-medium">
                        Debes seleccionar al menos un servicio para continuar
                      </p>
                    </div>
                  </div>
                )}
                
                {formData.categorias.length > 0 && (
                  <div className="bg-green-50 border-l-4 border-green-400 rounded-lg p-4">
                    <div className="flex items-center mb-3">
                      <div className="text-green-400 mr-3">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <p className="text-sm text-green-700 font-medium">
                        Servicios seleccionados ({formData.categorias.length})
                      </p>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {formData.categorias.map(servicio => (
                        <span 
                          key={servicio} 
                          className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium"
                        >
                          {servicio}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Marcas */}
          <div className="bg-gray-50 rounded-xl p-6">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center">
                <span className="text-orange-600 text-lg">🚗</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Marcas que Atiende *</h3>
            </div>
            
            {/* Buscador de marcas */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Buscar o agregar marca
              </label>
              <div className="flex space-x-3">
                <div className="flex-1 relative">
                  <input
                    type="text"
                    value={busquedaMarca}
                    onChange={(e) => setBusquedaMarca(e.target.value)}
                    placeholder="Escribe para buscar o agregar una marca..."
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 pr-10"
                  />
                  {busquedaMarca && (
                    <button
                      type="button"
                      onClick={() => setBusquedaMarca('')}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    >
                      ✕
                    </button>
                  )}
                </div>
                <button
                  type="button"
                  onClick={async () => {
                    if (busquedaMarca.trim() && 
                        !formData.marcas.includes(busquedaMarca.trim()) &&
                        !marcasDisponibles.find(m => m.nombre.toLowerCase() === busquedaMarca.trim().toLowerCase())) {
                      const nuevaMarca = busquedaMarca.trim();
                      const { ok } = await registrarMarcaEnCatalogo(nuevaMarca);
                      if (ok) {
                        setMarcasDisponibles(prev => [...prev, { id: nuevaMarca.toLowerCase().replace(/\s+/g, '_'), nombre: nuevaMarca }]);
                      }
                      setMarcasPersonalizadas(prev => [...prev, nuevaMarca]);
                      setFormData(prev => ({
                        ...prev,
                        marcas: [...prev.marcas, nuevaMarca]
                      }));
                      setBusquedaMarca('');
                    } else if (busquedaMarca.trim() && 
                               marcasDisponibles.find(m => m.nombre.toLowerCase() === busquedaMarca.trim().toLowerCase()) &&
                               !formData.marcas.includes(busquedaMarca.trim())) {
                      // Si la marca existe, agregarla
                      const marcaExistente = marcasDisponibles.find(m => m.nombre.toLowerCase() === busquedaMarca.trim().toLowerCase());
                      handleMarcaChange(marcaExistente.nombre);
                      setBusquedaMarca('');
                    }
                  }}
                  disabled={!busquedaMarca.trim()}
                  className="px-4 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors font-medium"
                >
                  + Agregar
                </button>
              </div>
            </div>
            
            {/* Marcas filtradas */}
            <div className="mb-4">
              <p className="text-sm text-gray-600 mb-3">
                {busquedaMarca 
                  ? `Resultados para "${busquedaMarca}":` 
                  : 'Selecciona marcas disponibles:'}
              </p>
              <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-2 max-h-48 overflow-y-auto p-2 bg-white rounded-lg border border-gray-200">
                {marcasDisponibles
                  .filter(marca => 
                    !busquedaMarca || 
                    marca.nombre.toLowerCase().includes(busquedaMarca.toLowerCase())
                  )
                  .map(marca => (
                    <label 
                      key={marca.id} 
                      className={`flex items-center space-x-2 cursor-pointer p-2 rounded-lg transition-colors ${
                        formData.marcas.includes(marca.nombre) 
                          ? 'bg-orange-100 border border-orange-300' 
                          : 'hover:bg-gray-100'
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={formData.marcas.includes(marca.nombre)}
                        onChange={() => handleMarcaChange(marca.nombre)}
                        className="rounded border-gray-300 text-orange-600 focus:ring-orange-500"
                      />
                      <span className="text-sm text-gray-700">{marca.nombre}</span>
                    </label>
                  ))}
                {busquedaMarca && !marcasDisponibles.some(m => m.nombre.toLowerCase().includes(busquedaMarca.toLowerCase())) && (
                  <div className="col-span-full text-center py-4 text-gray-500">
                    <p>No se encontraron marcas. Haz clic en "Agregar" para crear una nueva.</p>
                  </div>
                )}
              </div>
            </div>
            
            {/* Marcas personalizadas agregadas */}
            {marcasPersonalizadas.length > 0 && (
              <div className="mb-4 p-3 bg-orange-50 rounded-lg border border-orange-200">
                <p className="text-sm text-orange-800 mb-2 font-medium">Marcas personalizadas agregadas:</p>
                <div className="flex flex-wrap gap-2">
                  {marcasPersonalizadas.map(marca => (
                    <span 
                      key={marca} 
                      className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm flex items-center gap-2"
                    >
                      {marca}
                      <button
                        type="button"
                        onClick={() => {
                          setMarcasPersonalizadas(prev => prev.filter(m => m !== marca));
                          setFormData(prev => ({
                            ...prev,
                            marcas: prev.marcas.filter(m => m !== marca)
                          }));
                        }}
                        className="text-orange-600 hover:text-orange-800 font-bold"
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              </div>
            )}
            
            {/* Validación y resumen */}
            {formData.marcas.length === 0 && (
              <div className="bg-red-50 border-l-4 border-red-400 rounded-lg p-4">
                <div className="flex items-center">
                  <div className="text-red-400 mr-3">⚠️</div>
                  <p className="text-sm text-red-700 font-medium">
                    Debes seleccionar al menos una marca
                  </p>
                </div>
              </div>
            )}
            {formData.marcas.length > 0 && (
              <div className="bg-green-50 border-l-4 border-green-400 rounded-lg p-4">
                <div className="flex items-center mb-2">
                  <div className="text-green-400 mr-3">✓</div>
                  <p className="text-sm text-green-700 font-medium">
                    Marcas seleccionadas ({formData.marcas.length})
                  </p>
                </div>
                <div className="flex flex-wrap gap-2">
                  {formData.marcas.map(marcaNombre => (
                    <span 
                      key={marcaNombre} 
                      className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium flex items-center gap-1"
                    >
                      {marcaNombre}
                      <button
                        type="button"
                        onClick={() => {
                          handleMarcaChange(marcaNombre);
                          setMarcasPersonalizadas(prev => prev.filter(m => m !== marcaNombre));
                        }}
                        className="text-green-600 hover:text-green-800 font-bold ml-1"
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Descripción */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Descripción
            </label>
            <textarea
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              rows="3"
              className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Descripción breve de la empresa y sus servicios..."
            />
          </div>

          {/* Asignar Agente */}
          <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4">
            <label className="block text-sm font-medium text-indigo-900 mb-2">
              👤 Asignar Agente (Opcional)
            </label>
            <p className="text-xs text-indigo-700 mb-3">
              Selecciona un agente de campo para que realice la validación de esta empresa.
            </p>
            {loadingAgentes ? (
              <div className="flex items-center text-indigo-600">
                <svg className="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Cargando agentes...
              </div>
            ) : agentesDisponibles.length === 0 ? (
              <p className="text-sm text-gray-600">No hay agentes disponibles</p>
            ) : (
              <select
                value={agenteSeleccionado}
                onChange={(e) => setAgenteSeleccionado(e.target.value)}
                className="w-full p-3 border border-indigo-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"
              >
                <option value="">-- Sin asignar agente --</option>
                {agentesDisponibles.map((agente) => (
                  <option key={agente.id} value={agente.id}>
                    {agente.nombre || agente.email} {agente.zona_asignada ? `(${agente.zona_asignada})` : ''}
                  </option>
                ))}
              </select>
            )}
            {agenteSeleccionado && (
              <div className="mt-2 flex items-center text-sm text-indigo-700">
                <span className="mr-2">✓</span>
                Agente seleccionado: <strong className="ml-1">{agentesDisponibles.find(a => a.id === agenteSeleccionado)?.nombre || 'N/A'}</strong>
              </div>
            )}
          </div>

          {/* Botones de acción mejorados */}
          <div className="bg-white border-t border-gray-200 p-6">
            <div className="flex justify-end space-x-4">
              <button
                type="button"
                onClick={onClose}
                className="px-8 py-3 border-2 border-gray-300 rounded-xl text-gray-700 hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-all duration-200 font-medium"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading || (logoFile && !logoUploaded)}
                className="px-8 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-xl hover:from-green-700 hover:to-green-800 focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50 font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-200 flex items-center space-x-2"
              >
                {loading ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    <span>Creando...</span>
                  </>
                ) : (
                  <>
                    <span>💾</span>
                    <span>Guardar Empresa</span>
                  </>
                )}
              </button>
            </div>
          </div>
          
          {/* Aviso sobre el logo */}
          {logoFile && !logoUploaded && (
            <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
              <div className="flex items-center gap-2 text-yellow-800">
                <span className="text-lg">⚠️</span>
                <span className="text-sm">
                  <strong>Importante:</strong> Debes esperar a que el logo se suba completamente antes de guardar la empresa.
                </span>
              </div>
            </div>
          )}
        </form>
          </div>
        </div>
      </div>
    </div>
  );
}
